import {getSortGridAllocationForNode} from "../resources/GridAllocationResource";

export const FETCH_ALLOCATION_DATA_START = "FETCH_ALLOCATION_DATA_START";
export const RENDER_ALLOCATION_DATA = "RENDER_ALLOCATION_DATA";
export const FETCH_ALLOCATION_DATA_FAILURE = "FETCH_ALLOCATION_DATA_FAILURE";

/**
 * Fetch the grid allocation data from backend
 *
 * @param nodeId identifier of the node
 * @returns {(function(*): Promise<void>)|*}
 */
export const getGridAllocationDataForNode = (nodeId) => {
    return async (dispatch) => {
        dispatch(fetchAllocationDataStart());
        try {
            const allocationData = await getSortGridAllocationForNode(nodeId);
            if (allocationData) {
                dispatch(renderAllocationData(allocationData));
            } else {
                dispatch(fetchAllocationDataFailure());
            }
        } catch (error) {
            dispatch(fetchAllocationDataFailure());
        }
    }
}

/**
 * Fetch Allocation data start.
 */
export const fetchAllocationDataStart = () => ({
    type: FETCH_ALLOCATION_DATA_START
});

/**
 * Fetch Allocation data failure.
 */
export const fetchAllocationDataFailure = () => ({
    type: FETCH_ALLOCATION_DATA_FAILURE
});

/**
 * Fetch Allocation success and render
 */
export const renderAllocationData = (data) => ({
    type: RENDER_ALLOCATION_DATA,
    data: data
});


// WEBPACK FOOTER //
// ./src/actions/GridAllocationActions.js